<template>
  <v-layout row wrap justify-center align-center class="pt-8 pb-5 no-gutters">
    <v-flex xs12 sm9 class="mt-1 text-center">
      <v-timeline v-if="cargoDirectivos" style="z-index:0!important;" :dense="$vuetify.breakpoint.smAndDown">
        <v-timeline-item
          v-for="(directivo , n ) in this.directivosOrden"
          :key="'directivo-'+n"
          small

          >
          <template v-slot:icon>
            <v-avatar size="70">
              <v-img aspect-ratio="1" cove:ripple="false" :src="directivo.foto"></v-img>
            </v-avatar>
          </template>
          <template v-slot:opposite>
            <p class="ma-0 pa-0 text-nombres txt-primary lh-1">{{directivo.nombres}} {{directivo.apellidos}}</p>
          </template>
          <v-card class="elevation-2">
            <div class="px-2 pt-2 text-left" v-if="$vuetify.breakpoint.smAndDown">
              <p class="ma-0 pa-0 text-nombres txt-primary lh-1">{{directivo.nombres}} {{directivo.apellidos}}</p>
            </div>
            <div class="text-cargo px-2 pt-2 ma-0 text-left">
              {{directivo.cargo}}
            </div>
            <v-card-text class="pa-2 ma-0">
             <ul class="list-directivo">
              <li v-if="directivo.correo_electronico"><v-icon small>mdi-mail</v-icon> {{directivo.correo_electronico}}</li>
              <li v-if="directivo.telefono"><v-icon small>mdi-phone</v-icon> {{directivo.telefono}}</li>
              <li v-if="directivo.fecha_posesion"><v-icon small>mdi-calendar</v-icon> Fecha de posesión: {{directivo.fecha_posesion}}</li>
             </ul>
            </v-card-text>
          </v-card>
        </v-timeline-item>
      </v-timeline>
    </v-flex>
  </v-layout>
</template>
<script>
import axios from 'axios'
export default {
  data () {
    return {
      directivos: [],
      directivosOrden: [],
      cargoDirectivos: false

      // apellidos: "Mojica Rubio"
      // cargo: "Gerente General"
      // correo_electronico: "gerencia@eaav.gov.co"
      // fecha_posesion: "12-01-2021"
      // foto: "https://stage.eaav.gov.co/storage/directivos/August2022/X8ORLK8ORCDE9h5gfMla.png"
      // id_directivo: 1
      // nombres: "Efrain"
      // prioridad: 1
      // telefono: "(57) 86818080 Ext 801"
    }
  },
  async mounted () {
    this.cargoDirectivos = false
    await axios
      .get('' + this.$store.state.rutaApi + 'directivos')
      .then(response => (this.directivos = response.data))
    this.directivos.forEach(element => {
      this.directivosOrden.splice(element.prioridad - 1, 0, element)
    })
    // console.log('directivosOrden ', this.directivosOrden)
    // console.log(this.directivos)
    this.cargoDirectivos = true
  }
}
</script>
<style lang="scss" scoped>
.list-directivo{
  text-align: left;
  list-style: none;
  padding: 0px;
  li{
    padding: 0px;
  }
}
.text-nombres{
  font-size: 1.3em;
  font-weight: 600;
}
.text-cargo {
  font-size: 1.1em;
  font-weight: 600;
  line-height: 1em;
}
</style>
